// extracted by mini-css-extract-plugin
export var homeLoansContainer = "q_5";
export var title = "q_7";
export var titleContainer = "q_6";